'use client'

// React Imports
import React, { useState } from 'react'

// MUI Imports
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// Layout & Component Imports
import GridMainPanelLayout from '../../../../../components/common/Panels/GridMainPanelLayout'
import CustomerLedgerDetail from './CustomerLedgerDetail'

const CustomerLedgerCard = ({ data, loading }) => {
    const [selectedItem, setSelectedItem] = useState(null)

    if (!loading && (!data || data.length === 0)) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
                <Typography color="textSecondary">No customer ledger records found.</Typography>
            </Box>
        )
    }

    // Map ledger data to the format expected by GridMainPanelLayout
    const mappedData = data ? data.map((item, index) => ({
        ...item,
        id: index, // Using index as ID if there is no unique ID
        title: item.Customer || 'Unknown Customer',
        personName: item.Customer,
        date: item.LeadNo ? `Lead No: ${item.LeadNo}` : 'N/A',
        _statusClass: item.Balance < 0 ? 'overdue' : 'completed', // Map overdue (red) vs completed (green)
        _badgeText: item.Balance < 0 ? 'Balance Due' : 'Balance Clear',
        iconClass: 'ri:file-list-3-line' // Custom icon for ledger
    })) : []

    const currentSelectedItem = selectedItem || (mappedData.length > 0 ? mappedData[0] : null)

    return (
        <GridMainPanelLayout
            type="task" // Use task type to hide checkboxes if hideSelection is set, or we can use custom type
            hideSelection={true} // Customer ledger lists shouldn't have checkboxes
            hideSidebarHeader={true} // Removes "Task List" title
            data={mappedData}
            loading={loading}
            selectedItem={currentSelectedItem}
            onSelectItem={setSelectedItem}
            renderDetailContent={(item) => (
                <CustomerLedgerDetail detail={item} />
            )}
        />
    )
}

export default CustomerLedgerCard
